import React, { useEffect, useState } from 'react';
import BoostFormProps from './BoostFormProps';
import Stepper from '../../small/stepper/stepper';
import Utils from '../../../utils/Utils';
import i18next from 'i18next';
import { Avatar, Button } from '@material-ui/core';
import './BoostForm.scss';
import { useDispatch, useSelector } from 'react-redux';
import ReduxStoreInterface from '../../../model/ReduxStoreInterface';
import { actionStackAssetShares } from '../../../service/wallet/actions';
import CircularLoader from '../../small/CircularLoader';
import { managementModal } from '../../../service/modal/action';
import { PERCENTAGE_OF_SHARES_TO_TRANSFERT } from 'config/_const';
import Application from 'Application';
const BoostForm: React.FC<BoostFormProps> = ({ assetWalletElement }) => {
  const MINIMUM_BOOST_AMOUNT: number = 5;
  const dispatch = useDispatch();

  const walletIsLoading = useSelector((state: ReduxStoreInterface) => state.wallet.loading);
  const userId = useSelector((state: ReduxStoreInterface) => state.auth.data.account._id);

  const [amountOfSharesToBoost, setAmountOfSharesToBoost] = useState<number>(assetWalletElement.amount);
  const [bonus, setBonus] = useState<number>(0);
  const [showBoostError, setShowBoostError] = useState<boolean>(false);

  useEffect(() => {
    if (amountOfSharesToBoost < MINIMUM_BOOST_AMOUNT)
      setShowBoostError(true);
    if (amountOfSharesToBoost >= MINIMUM_BOOST_AMOUNT)
      setShowBoostError(false);
    switch (true) {
      case amountOfSharesToBoost > assetWalletElement.amount:
        setAmountOfSharesToBoost(assetWalletElement.amount);
        break;
      case amountOfSharesToBoost < 0:
        setAmountOfSharesToBoost(0);
        break;
    }
    setBonus(Math.floor((amountOfSharesToBoost * PERCENTAGE_OF_SHARES_TO_TRANSFERT) / 100));
  }, [amountOfSharesToBoost, assetWalletElement.amount]);

  return (
    <>
      <div className="boost-form">
        <p>{i18next.t('boost.explanation.block1')}</p>
        <p>{i18next.t('boost.explanation.block2', { brand: Application.getInstance().brand })}</p>
        <p>{i18next.t('boost.chooseAmount')}</p>
        <h4 className="title">{i18next.t('resale.amountOfSharesHeld', { amount: assetWalletElement.amount })}</h4>
        <div className="container-payment" style={{ borderRadius: '15px' }}>
          <Stepper
            preventDefaultOnChangeEvent={false}
            inputDefaultValue={amountOfSharesToBoost}
            onAddButtonClicked={() => {
              setAmountOfSharesToBoost(amountOfSharesToBoost + 1);
            }}
            onInputChange={(value: string) => {
              setAmountOfSharesToBoost(Utils.getCleanNumberInput(value));
            }}
            onRemoveButtonClicked={() => {
              setAmountOfSharesToBoost(amountOfSharesToBoost - 1);
            }}
            debouceOnChangeEvent={false}
          />
        </div>
        <div className="avatar-container">
          <Avatar
            className="avatar-70"
            src={assetWalletElement.asset.icon}
          />
        </div>
        <p className="asset-name">{assetWalletElement.asset.name}</p>
        <div>
          <p>{i18next.t('boost.bonusToReceive') + bonus}</p>
          <p>{i18next.t('boost.timeWarning')}</p>
          {showBoostError && <p style={{ color: 'red' }}>{i18next.t('boost.CannotBoostLessThanAmount', { amount: MINIMUM_BOOST_AMOUNT })}</p>}
        </div>
        <div style={{ display: 'inline-flex' }}>
          <Button variant="contained" className="boost-button cancel" type="button"
            onClick={() => dispatch(managementModal(false))}
          >
            {i18next.t('genericcancel')}
          </Button>
          <Button variant="contained" className="boost-button boost" type="button" disabled={showBoostError}
            onClick={() => dispatch(actionStackAssetShares(amountOfSharesToBoost, assetWalletElement.asset._id, userId))}
          >
            {i18next.t('Myportfolio.tbl2th.boost')}
          </Button>
        </div>
      </div>

      {walletIsLoading && (
        <CircularLoader
          loaderMessage={i18next.t('boost.loaderMessage')}
          loaderLocal={false}
          doNotSplitMessage={true} />)
      }
    </>
  );
};

export default BoostForm;
